import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

export const RowText = styled(Text14)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 400px;
`;
